// src/components/home/HomeHeroSection.jsx
import React from "react";

function HomeHeroSection() {
  return (
    <section className="home-hero-section py-3">
      <div className="container-fluid px-0">
        {/* Ligne slider + side banners */}
        <div className="row g-3">
          {/* SLIDER PRINCIPAL */}
          <div className="col-lg-9">
            <div
              id="homeMainCarousel"
              className="carousel slide home-hero-main"
              data-bs-ride="carousel"
              data-bs-interval="3000"   // 3 secondes entre chaque slide
              data-bs-pause="hover"     // le slider s'arrête quand la souris est dessus
            >
              {/* Indicateurs */}
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#homeMainCarousel"
                  data-bs-slide-to="0"
                  className="active"
                  aria-current="true"
                  aria-label="Slide 1"
                ></button>
                <button
                  type="button"
                  data-bs-target="#homeMainCarousel"
                  data-bs-slide-to="1"
                  aria-label="Slide 2"
                ></button>
                <button
                  type="button"
                  data-bs-target="#homeMainCarousel"
                  data-bs-slide-to="2"
                  aria-label="Slide 3"
                ></button>
                <button
                  type="button"
                  data-bs-target="#homeMainCarousel"
                  data-bs-slide-to="3"
                  aria-label="Slide 4"
                ></button>
              </div>

              {/* Slides */}
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img
                    src="/images/home/slider-main-4.gif"
                    className="d-block w-100 home-hero-main-img"
                    alt="Promo Tecno"
                  />
                </div>
                <div className="carousel-item">
                  <img
                    src="/images/home/slider-main-1.gif"
                    className="d-block w-100 home-hero-main-img"
                    alt="Promo Infinix"
                  />
                </div>
                <div className="carousel-item">
                  <img
                    src="/images/home/slider-main-2.gif"
                    className="d-block w-100 home-hero-main-img"
                    alt="Promo Huawei"
                  />
                </div>
                <div className="carousel-item">
                  <img
                    src="/images/home/slider-main-3.gif"
                    className="d-block w-100 home-hero-main-img"
                    alt="Outil pour la vente"
                  />
                </div>
              </div>

              {/* Flèches */}
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#homeMainCarousel"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Précédent</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#homeMainCarousel"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Suivant</span>
              </button>
            </div>
          </div>

          {/* BANNIÈRES DROITES */}
          <div className="col-lg-3 d-none d-lg-flex flex-column gap-3">
            <a href="#boutique" className="home-hero-side">
              <img
                src="/images/home/side-top.gif"
                alt="Rendez-vous en boutique"
                className="w-100 h-100 home-hero-side-img"
              />
            </a>

            <a href="#credit" className="home-hero-side">
              <img
                src="/images/home/side-bottom.gif"
                alt="Smartphones à crédit"
                className="w-100 h-100 home-hero-side-img"
              />
            </a>
          </div>
        </div>

        {/* LIGNE 3 BLOCS PROMO */}
        <div className="row g-3 mt-3 home-hero-promos">
          <div className="col-md-4">
            <a href="#decouvrir" className="home-hero-card">
              <img
                src="/images/home/slider-main-4.gif"
                alt="Découvrir"
                className="w-100 h-100 home-hero-card-img"
              />
            </a>
          </div>
          <div className="col-md-4">
            <a href="#redmi14" className="home-hero-card">
              <img
                src="/images/home/side-top.gif"
                alt="Redmi Note 14"
                className="w-100 h-100 home-hero-card-img"
              />
            </a>
          </div>
          <div className="col-md-4">
            <a href="#flash" className="home-hero-card">
              <img
                src="/images/home/side-bottom.gif"
                alt="Vente flash"
                className="w-100 h-100 home-hero-card-img"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeHeroSection;






